import React from 'react';
import { Container } from './styles';
import Tab from './Tab';
var VerticalTabs = function (_a) {
    /*
      items = [
        {name: {Component}, content: {Component}}
      ]
    */
    var items = _a.items;
    return (React.createElement(Container, null, items === null || items === void 0 ? void 0 : items.map(function (_a, id) {
        var Name = _a.name, Content = _a.content, defaultOpen = _a.defaultOpen;
        return (React.createElement(Tab, { key: id, name: Name, defaultOpen: defaultOpen },
            React.createElement(Content, null)));
    })));
};
export default VerticalTabs;
